/**
 * Spaces will be replaced with dashes ("-").
 *
 * Example: "i am legend" will be converted to "i-am-legend".
 */
export default function toDashCase(str: string): string {
  return str.replace(/\s/g, '-');
}
